import { action, SB } from '@play-co/replicant';
import ab, { ABTestID } from '../../ruleset/ab';
import createActions from './createActions';
import {
  AssignManualAbTestArgs,
  assignManualAbTests,
} from 'src/replicant/ab/ab.modifiers';

const testIdSchema = SB.string().customValidator((testId) => {
  if (!(testId in ab.config)) {
    return `Invalid test ID: '${testId}'`;
  }

  return '';
});

const abTestsSchema = SB.map(SB.string()).customValidator((value) => {
  const testIdErrors = Object.keys(value)
    .map((testId) => testIdSchema.validate(testId))
    .filter((error) => !!error)
    .join('\n');

  if (testIdErrors) {
    return testIdErrors;
  }

  const entries = Object.entries(value) as [ABTestID, string][];

  if (
    entries.some(
      ([testId, bucketId]) =>
        !ab.config[testId].buckets.find((bucket) => bucket.id === bucketId),
    )
  ) {
    return 'Invalid bucket ID';
  }

  return '';
});

type AbTests = SB.ExtractType<typeof abTestsSchema>;

export default createActions({
  setAbTests: action((state, args: AbTests) => {
    abTestsSchema.tryValidate(args);

    state.abTests = args;
  }),

  addAbTests: action((state, args: AbTests) => {
    abTestsSchema.tryValidate(args);

    for (const test in args) {
      state.abTests[test] = args[test];
    }
  }),

  assignManualAbTests: action((state, args: AssignManualAbTestArgs, api) => {
    // Manually assign an AB test if no bucket is assigned yet.
    assignManualAbTests(state, args, api);
  }),
});
